import { INeoAction } from '../../Actions.interface';
import { isActionValid } from '~/Helpers/Reducer.helper';
import { STATUS, REQUEST_ACTIONS } from '~/Constants/Actions.constants';

import { ILocation } from '~/Models/DTO/Location.models';
import { updateItem } from '~/store/tools.helper';
import { isArray } from 'lodash-es';

const useValidActions = isActionValid([
  REQUEST_ACTIONS.LOCATION_LIST,
  REQUEST_ACTIONS.LOCATION_UPDATE,
  REQUEST_ACTIONS.LOCATION_CREATE,
]);

export default (state: ILocation[] = [], action: INeoAction) => {
  const { name, status, payload } = action;

  const actionValid = useValidActions(name);

  if (isActionValid([REQUEST_ACTIONS.GET_PROVIDER])(name)) {
    if (status === STATUS.SUCCESS) {
      return [];
    }
  }
  if (actionValid) {
    if (status === STATUS.SUCCESS) {
      if (isArray(payload)) {
        return payload;
      } else {
        return updateItem<ILocation>(state, payload, 'id');
      }
    }
  }
  return state;
};
